<template>
  <div>

    <FilterImagenes ref="filterImagenes" />

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">
        <b-col cols="12" class="pr-0 pl-0">

          <div
            v-if="showButtonReportes" 
            class="d-flex justify-content-end align-items-center"
          >
            <h5
              class="mr-2">Reporte:
            </h5>
            <b-button 
              class="ml-1" variant="outline-secondary" 
              title="Descargar Base Datos Imagenes"
              @click="descargarExcel" :disabled="descargandoBase">
              <div v-if="descargandoBase">
                <b-spinner small type="grow"></b-spinner>
                <label>Descargando..</label>
              </div>
              <i class="fas fa-file-alt"></i>
            </b-button>
          </div>
          <h5 class="text-right my-1 mx-1">Resultados: {{ table.totalRows }}</h5>
          
          <b-table 
            v-if="items.length > 0 && !loadingTable" 
            bordered striped responsive 
            :per-page="table.perPage"
            :items="items" 
            :fields="fields" 
            :sort-by.sync="sortBy" 
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" small
          >
            <template #cell(solicitudimagen)="data">
              <div class="d-flex justify-content-end">
                <b-button 
                  v-if="showInforme12A && data.item.urlSolImgDer && data.item.idDoctor === MEDICO_DERIVACIONES.IMAGENES"
                  title="Solicitud de imagen 12 A" size="sm"
                  @click="descargarSolicitudImagenDer(data.item.urlSolImgDer)">
                  12A
                </b-button>

                <b-button 
                  v-if="showInforme12A && (!data.item.urlSolImgDer || data.item.idDoctor !== MEDICO_DERIVACIONES.IMAGENES)"
                  title="Solicitud de Imagen 12 A" size="sm"
                  @click="downloadSolicitudImagen(data.item.idImagenEnviada)">
                  12A
                </b-button>

                <b-button 
                  v-if="showInformeActa" title="Acta Imagen" size="sm"
                  @click="downloadActaImagen(data.item.idCita)"
                >
                  <i class="fa-solid fa-i"/>
                </b-button>

                <b-button 
                  v-if="showInforme12B && data.item.estadoImagen === 'Terminada'" 
                  title="Informe de Imagen 12 B"
                  size="sm" @click="onViewFile12b(data.item.token)">
                  <i class="fa-solid fa-b"/>
                </b-button>

                <b-button 
                  v-if="showButtonTirilla && data.item.tirilla" 
                  title="Ver Tirilla Derivacion" size="sm"
                  @click="verDocumento(data.item.tirilla)">
                  <i class="fa-solid fa-file-invoice"/>
                </b-button>

                <b-button 
                  v-if="showButtonMSP && data.item.msp && data.item.msp !== 'No subido'" 
                  title="Ver Msp"
                  size="sm" 
                  @click="verDocumento(data.item.msp)"
                >
                  <i class="fa-solid fa-file-lines"/>
                </b-button>
              </div>
            </template>

            <template #cell(imagen)="data">
              
              <div class="d-flex justify-content-center">
                <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.imagen">
                  {{
                    data.item.imagen
                      ? data.item.imagen.split(" ").slice(0, 2).join(" ") +"..."
                      : ""
                  }}
                </div>
              </div>
            </template>
            <template #cell(msp)="data">
              <div 
                style="text-align: center;" 
                :class="data.item.cobertura.descripcion !== 'PARTICULAR' ? data.item.colorArchivoMsp : '' "
              >
                {{ 
                  data.item.cobertura.descripcion !== 'PARTICULAR' ? `subido ${data.item.nCoberturasSubidas}/${data.item.nTitulares}` : `` 
                }}
              </div>
            </template>

            <template #cell(cobertura)="data">
              <div class="d-flex justify-content-center">
                {{
                  data.item.cobertura_tiposeg
                }}
              </div>
            </template>

            <template #cell(motivoSolicitud)="data">
              <div class="d-flex justify-content-center">
                <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.motivoSolicitud">
                  {{
                    data.item.motivoSolicitud
                      ? data.item.motivoSolicitud.split(" ").slice(0, 4).join(" ") + "..."
                      : ""
                  }}
                </div>
              </div>
            </template>

            <template #cell(resumen)="data">
              <div class="d-flex justify-content-center">
                <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.resumen">
                  {{
                    data.item.resumen
                      ? data.item.resumen.split(" ").slice(0, 4).join(" ") +"..."
                      : ""
                  }}
                </div>
              </div>
            </template>
            <template #cell(acciones)="data">

              <div class="d-flex justify-content-end">

                <b-button 
                  size="sm" 
                  title="Ver Imagen Programada" 
                  variant="info"
                  @click="onViewImagenProgramada(data.item.token)">
                  <i class="fa-solid fa-magnifying-glass" />
                </b-button>

                <b-button 
                  v-if="showButtonEditarDerivada && data.item.idDoctor === MEDICO_DERIVACIONES.IMAGENES"
                  title="Editar Imagen Derivada" variant="warning" size="sm" @click="editarImgDerivada(data.item)">
                  <i class="fa-solid fa-pen-to-square" />
                </b-button>

                <b-button v-if="showButtonEditarSolicitud
                  && data.item.estadoImagen !== 'Terminada'
                  && data.item.idDoctor !== MEDICO_DERIVACIONES.IMAGENES
                " title="Editar Solicitud Imagen" variant="warning" size="sm" @click="editaSolicitudImagen(data.item)">
                  <i class="fa-solid fa-pencil" />
                </b-button>
                <!-- Botón para editar (Calendario) -->
                <b-button 
                  v-if="showButtonProgramarImagen && data.item.estadoImagen === 'Creado'" 
                  variant="primary"
                  title="Programar" size="sm" @click="editItem(data.item.idImagenEnviada, '1')">
                  <i class="fas fa-calendar" style="color: white" />
                </b-button>

                <b-button 
                  v-if="showButtonProgramarImagen && data.item.estadoImagen !== 'Creado'"
                  :disabled="esFechaHoy(data.item.idImagenEnviada)" variant="warning" title="Reprogramar Fecha"
                  size="sm" @click="editItem(data.item.idImagenEnviada, '0')">
                  <i class="fas fa-calendar" style="color: white"></i>
                </b-button>

                <b-button 
                  v-if="showButtonProcesarImagen(data.item.estadoImagen)" 
                  :variant="data.item.estadoImagen === 'Programada'? 'primary' : 'warning'" 
                  size="sm" title="Procesar" 
                  @click="onProcesarImagen(data.item.token, data.item.coberturasSubidas, data.item.cobertura)">
                  <i class="fas fa-spinner" style="color: white" />
                </b-button>


                <!-- <b-button
                  v-if="showButtonDeleteImagen"
                  variant="danger"
                  size="sm"
                  @click="removeItemid(data.item.idSolicitudTerapia)"
                >
                  <font-awesome-icon icon="circle-xmark" style="color: white" />
                </b-button> -->
              </div>
            </template>
          </b-table>
          
          <div v-if="loadingTable">
            <b-skeleton-table :rows="15" :columns="14" :table-props="{ bordered: true, striped: true }" />
          </div>

          <div v-if="items && items.length < 1 && !loadingTable" class="text-center">
            <p>No se encontraron registros</p>
          </div>

        </b-col>



        <b-modal id="modal-editar-fecha" ok-title="Asignar" cancel-title="Cancelar" @ok="
          actualizarFechaProgramada(
            idImagenEnviada,
            fechaProgramadaSeleccionada,
            cambiarEstado
          )
        ">
          <template #modal-title>
            <h3 class="modal-title">Programar fecha de imagen</h3>
          </template>
          <template #default>
            <div class="my-3">
              <label for="fecha-programada">Seleccione la fecha:</label>

              <b-form-input 
                id="fecha-programada" 
                type="datetime-local" 
                v-model="fechaProgramadaSeleccionada"
                class="form-control" />
            </div>
          </template>

          <template #modal-footer="{ ok, cancel, hide }">
            <b-button variant="secondary" @click="cancel"> Cancelar </b-button>
            <b-button variant="primary" @click="ok"> Asignar </b-button>
          </template>
        </b-modal>

        <b-modal 
          id="edit-modal" 
          v-model="showEditModal" 
          title="Editar Diagnóstico" 
          ok-title="Guardar"
          cancel-title="Cancelar"
        >
          <b-form>
            <b-form-group label="Diagnóstico" label-for="edit-diagnostico">
              <v-select 
                placeholder="Escriba un diagnóstico..." 
                v-model="editForm.diagnostico"
                :options="filteredOptions" 
                :reduce="(option) => option.id" 
                label="text" 
                @search="onSearchDiagnosticos"
              >
                <template #no-options>
                  {{ noOptionsMessage }}
                </template>
              </v-select>
            </b-form-group>
          </b-form>
        </b-modal>


        <b-col cols="12" class="mb-2">
          <b-pagination 
            v-if="items.length > 0" 
            v-model="table.currentPage" 
            :total-rows="table.totalRows"
            :per-page="table.perPage" 
            :small="true" 
            first-number 
            class="mb-0" 
            align="center" 
            prev-class="prev-item"
            next-class="next-item" 
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>


    <ModalProcesarImagen />

    <b-modal id="modal-tirilla" size="xl">
      <b-card>
        <iframe :src="ruta" width="100%" height="500px" frameborder="0">
        </iframe>
      </b-card>
    </b-modal>

    <b-modal 
      id="modal-editar-imagenderivada" 
      title="Editar Datos Imagen Derivada" 
      size="xl" hide-footer
    >
      <EditarImagenDerivada :dataImagenDerivada="dataImagenDerivada" />
    </b-modal>

    <b-modal 
      id="modal-editar-solicitudimagen" 
      title="Editar Solicitud Imagen" 
      size="xl" hide-footer
    >
      <EditarSolicitudImagen />
    </b-modal>


    <VerImagenProgramada />

    <ModalViewFile 
      v-if="modalFile.fileToView" 
      :urlFile="modalFile.fileToView" 
      :rutaCompleta=modalFile.isRutaCompleta
      v-model="modalFile.isVisible" 
    />

  </div>
</template>

<script>
import { BootstrapVue } from "bootstrap-vue";
import { mapState } from "vuex";

import actions from "@/assets/utils/utils";
import vSelect from "vue-select";
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS, getIdDoctorLS, getDataDoctor } from "@/shared/helpers";
import { ModalViewFile } from '@/shared/components';
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import "flatpickr/dist/flatpickr.css";

import { ROLES, MEDICO_DERIVACIONES, ESPECIALIDAD } from "@/shared/constants";
import { ModalProcesarImagen, VerImagenProgramada, FilterImagenes } from "../components";
import EditarImagenDerivada from "../components/EditarImagenDerivada/EditarImagenDerivada.vue";
import EditarSolicitudImagen from "../components/EditarSolicitudImagen/EditarSolicitudImagen.vue";
// import { fetchTipoImagenSelect }      from '../services/tipoImagen';
import { imagenesService } from "../services";


export default {
  components: {
    ...BootstrapVue.components,
    vSelect,
    EditarImagenDerivada,
    EditarSolicitudImagen,
    ModalProcesarImagen,
    VerImagenProgramada,
    ModalViewFile,
    FilterImagenes
  },

  data() {
    return {

      descargandoBase: false,

      filters: null,


      MEDICO_DERIVACIONES,
      ruta: null,
      fechaMinima: this.calcularFechaMinima(),

      cambiarEstado: "0",

      flatpickrConfig: {
        allowInput: true, // Muestra un campo de entrada de texto adicional
        minDate: "1900-01-01",
        maxDate: new Date(),
        enableTime: true,
      },
      idDoctor: null,

      codG: [
        "0000000001",
        "0000000013",
        "0000000012",
        "0000000017",
        "0000000018",
        "0000000019",
        "0000000020",
      ],
      codImg: [
        "0000000009",
        "0000000022",
      ],
      dataImagenDerivada: null,
      pagina_actual: 1,
      currentPageModificado: 1,
      mostrarLoader: false,
      fecha: null,
      hora: null,
      login_user: "",
      fechaProgramadaSeleccionada: null,
      establecimiento: "",
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),
      doctorInfo: null,
      doctorEspecialidades: [],
      doctorEspecialidadDescripcion: '',

      table: {
        currentPage: 1,
        perPage: 15,
        totalRows: 0
      },
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },


      listaAcciones: [],
      loadingTable: true,
      token_usuario: "",
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
      },
      items: [],
      descripcion: "",


      tipoImagenOpts: [],


      opsDiagnosticos: [],
      diagnosticos: [],
      diagnosticosearch: null,
      editForm: {
        diagnostico: "",
      },
      informacionImagen: {
        fechaImagen: "",
        imagen: "",
        codigoImagen: "",
        primerNombre: "",
        primerApellido: "",
      },

      urlInforme: "",

      showEditModal: false,
      informe: null,
      conclusion: "",
      imagenologo: null,
      isLoading: false,

      idEnvioImagen: null,
      idEstablecimiento: null,

      showModalVerImagen: true,

      modalFile: {
        fileToView: null,
        isVisible: false,
        isRutaCompleta: false
      },

      load12b: false
    };
  },



  async created() {
    comprobarPermisos(this.$route);

    this.setToken();
    await this.loadFiltersLS();
    const doctorData = getDataDoctor();
    this.doctorInfo = doctorData || null;
    this.doctorEspecialidadDescripcion = doctorData?.especialidad?.descripcion || '';
    const detalleUsuario = JSON.parse(localStorage.getItem('detalleusuario') || '{}');
    const doctorSet = Array.isArray(detalleUsuario?.persona?.doctorSet)
      ? detalleUsuario.persona.doctorSet
      : [];
    this.doctorEspecialidades = doctorSet;
    if (!this.doctorInfo && doctorSet.length) {
      this.doctorInfo = doctorSet[0];
      this.doctorEspecialidadDescripcion = doctorSet[0]?.especialidad?.descripcion || '';
    }

    // this.getDataTable();
    this.totalPages();
  },

  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
    isVisibleSecond: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: " Título predeterminado",
    },
  },


  mounted() {
    actions.setearTitulo("Imagenes Programadas");
  },

  methods: {

    esEspecialidadOdontologiaCe(descripcion, codigo = null) {
      const allowedCodes = [ESPECIALIDAD.ODONTOLOGIA, '2'];
      const formattedCode = (codigo !== null && codigo !== undefined)
        ? String(codigo).trim()
        : '';

      if (formattedCode && allowedCodes.includes(formattedCode)) {
        return true;
      }

      const normalized = (descripcion || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .replace(/\s+/g, ' ')
        .trim();

      if (!normalized) return false;
      if (normalized.includes('ODONTOLOGIA (CE)')) return true;
      if (normalized.includes('ODONTOLOGIA') && normalized.includes('CE')) return true;

      return false;
    },

    tieneEspecialidadOdontologia(doctor) {
      if (!doctor) return false;
      const especialidad = doctor.especialidad || {};
      const descripcion = especialidad.descripcion || '';
      const codigo = especialidad.codEsp || especialidad.codigo || especialidad.id || especialidad.token;
      const codigoAlt = doctor.codEspecialidad || doctor.especialidadId || doctor.idEspecialidad;

      if (this.esEspecialidadOdontologiaCe(descripcion, codigo)) return true;
      if (codigoAlt && this.esEspecialidadOdontologiaCe('', codigoAlt)) return true;

      return false;
    },


    showButtonProcesarImagen(estadoImagen) {

      const estadoPermitido = ["Programada", "Incompleto", "Terminada"];
      if (!estadoPermitido.includes(estadoImagen)) return false;

      const hasPermission = comprobarRoles([ROLES.ADMINISTRADOR, ROLES.JEFE_MEDICO, ROLES.IMAGENES, ROLES.AUX_IMAGENES, ROLES.AGENDAMIENTO, ROLES.ADMISION]);
      return hasPermission;
    },

    loadFiltersLS() {
      const dataFiltersLs = JSON.parse(localStorage.getItem('filterImagenes'));
      if (!dataFiltersLs) return;
      this.filters = dataFiltersLs;
    },


    onViewImagenProgramada(tokenImagen) {
      this.$router.push({ name: "consultar-imagenes", query: { 'view_imagen': tokenImagen } });
    },


    async downloadActaImagen(idCita) {
      const query = `                
        query qrGetDocumentActa($idCita: String!, $servicio : String) {
          getDocumentActa(idCita: $idCita, servicio: $servicio) {
            status
            message
            citaPdf
            cita{
              id
              fechaCita
              horaCita
              paciente{
                persona{
                  primerNombre
                  primerApellido
                  identificacion
                }
              }
            }
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', {
          query,
          variables: { idCita, servicio: 'IMAGEN' }
        });
        if (response.status === 200) {
          const item = response.data.data.getDocumentActa.citaPdf;
          actions.cargarArchivos(item, "acta_" + idCita + ".pdf", "data:application/pdf;base64");
        }
      } catch (error) {
        console.error("Error al cargar la cobertura:", error);
      }

    },

    async cargarDataImagenes(imagen) {
      const imagenesList = [];
      if (imagen && imagen.length > 0) {
        imagen.forEach((img) => {
          imagenesList.push({
            alertaIgnorada: img.alertaIgnorada,
            imagenId: img.imagen.id,
            imagentext: img.imagen.nombre,
            lateralidad: img.lateralidad.descripcion,
            lateralidadId: img.lateralidad.id,
            motivosolicitud: img.motivoSolicitud,
            norden: img.numeroOrdenAs400,
            resumen: img.resumenClinico,
            tokenEnvioImagen: img.token,
            estado: img.estado,
            sedacion: img.sedacion,
          });
        });
      }
      return imagenesList;
    },

    async editarImgDerivada(data) {
      this.$store.commit("resetFiles");

      if (data.envioImagenSet && data.envioImagenSet.length > 0) {
        const imagen = data.envioImagenSet;

        const imagenList = await this.cargarDataImagenes(imagen);
        this.$store.commit("setImagenesList", imagenList);
        localStorage.setItem("idEstabCita", data.idEstablecimiento);
      }

      this.dataImagenDerivada = {
        cobSeleccionada: data.cobSeleccionada,
        paciente: data.paciente,
        idPaciente: data.idPaciente,
        identificacionPaciente: data.identificacionPaciente,
        fecderivacion: data.fecderivacion,
        codderivacion: data.codderivacion,
        urlSolImgDer: data.urlSolImgDer,
        idCita: data.idCita,
        idImagenEnviada: data.idImagenEnviada,
        itemCit: {
          urlmsppac: data.urlsMspPaciente,
          urlmsptit1: data.urlsMspTitular1,
          urlmsptit2: data.urlsMspTitular2,
          urlmsptit3: data.urlsMspTitular3,
          urlDerivacion: data.urlDerivacion,
          urlCodDerivacion: data.tirilla,
          urlSolicitudImagen: data.urlSolImgDer,
          url007Recibido: data.url007Recibido
        },
      };

      this.$bvModal.show("modal-editar-imagenderivada");
    },

    async editaSolicitudImagen(data) {
      let imagen = null;

      if (data.envioImagenSet && data.envioImagenSet.length > 0) {
        data.envioImagenSet.forEach((item) => {
          if (data.imagen.trim() === item.imagen.nombre.trim()) {
            imagen = [item];
          }
        });

        const imagenList = await this.cargarDataImagenes(imagen);
        this.$store.commit("setImagenesList", imagenList);
        localStorage.setItem("idEstabCita", data.idEstablecimiento);
      }

      this.$bvModal.show("modal-editar-solicitudimagen");
    },

    async verDocumento(url) {
      if (url) {
        const fileName = decodeURIComponent(url);
        const fullDownloadUrl = `${rutas.axios}file/show${fileName}`;
        try {
          this.ruta = fullDownloadUrl;


          this.$bvModal.show("modal-tirilla");
        } catch (error) {
          this.$swal({
            title: "Error",
            text: "Un error ocurrio mientras descarga el archivo",
            icon: "error",
            confirmButtonText: "Entendido",
          });
        }
      } else {
        this.$swal({
          title: "Campos vacíos",
          text: "El archivo no ha sido subido, por favor actualizar en editar cita",
          icon: "error",
          confirmButtonText: "Entendido",
        });
      }
    },

    calcularFechaMinima() {
      const hoy = new Date();
      hoy.setDate(hoy.getDate()); // Sumar un día
      return hoy.toISOString().slice(0, 16); // Formato YYYY-MM-DDTHH:MM
    },

    totalPages() {
      return 2;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    // onProcesarImagen(dataImagen) {
    //   if (!dataImagen) return;
    //   this.showModalProcesarImagen = true;
    //   this.procesarImagenData = dataImagen;
    // },


    onProcesarImagen(tokenImagen, coberturasSubidas, cobertura) {
      if (!tokenImagen) return;
      if (cobertura.trim() === 'PARTICULAR'){
      localStorage.setItem("coberturasSubidas", true)
      }else{
      localStorage.setItem("coberturasSubidas", coberturasSubidas)
      }
      this.$router.push({ name: "consultar-imagenes", query: { procesar: tokenImagen } });
    },


    handleButtonClick(idImagenEnviada, estadoImagen) {
      if (estadoImagen === "Programada") {
        this.imagenAtencion(idImagenEnviada);
      } else {
        this.editItem(idImagenEnviada);
      }
    },

    onSearchDiagnosticos(search, loading) {
      if (search.length > 5) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetDiagnosticos(search);
      } else {
        this.opsDiagnosticos = [];
        this.isLoading = false;
      }
      loading(false);
    },

    esFechaHoy(fechaProgramada) {
      const hoy = new Date();
      const fechaProgramadaDate = new Date(fechaProgramada);
      // Compara solo año, mes y día
      return (
        hoy.getFullYear() === fechaProgramadaDate.getFullYear() &&
        hoy.getMonth() === fechaProgramadaDate.getMonth() &&
        hoy.getDate() === fechaProgramadaDate.getDate()
      );
    },


    async descargarExcel() {
      this.descargandoBase = true
      await this.getReporteImagenes();

    },

    async cambiarPagina(paginaActual) {
      this.table.currentPage = paginaActual;
      await this.getDataTable();

    },


    imagenEjecucion(idImagenEnviada) {
      this.idImagenEnviada = idImagenEnviada;
      this.$bvModal.show("modal-imagen-ejecucion");
    },

    editItem(idImagenEnviada, cambiarEstado = "0") {
      this.idImagenEnviada = idImagenEnviada;
      this.cambiarEstado = cambiarEstado
      this.$bvModal.show("modal-editar-fecha");
    },

    async ejecutarImagen(idImagenEnviada, fechaEjecucion) {
      this.idImagenEnviada = idImagenEnviada;
      const ejeconfirmation = await this.$swal({
        title: "¿Estás seguro de ejectuar el proceso de imagen?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });
      if (ejeconfirmation.isConfirmed) {
        // El usuario confirmó la actualización, realizar la solicitud al servidor
        const mutation = `
          mutation ejecutarImagen($idEnvioImagen: String!, $fechaEjecucion: DateTime!) {
            ejecutarImagen(idEnvioImagen: $idEnvioImagen, fechaEjecucion: $fechaEjecucion) {
              imagenej {
                id
                fechaProgramada
              }
            }
          }
        `;

        const variables = {
          idEnvioImagen: idImagenEnviada,
          fechaEjecucion: fechaEjecucion.toString(),
        };

        try {
          const response = await axios.post(rutas.axios + "api", {
            query: mutation,
            variables: variables,
          });

          if (response.data.errors) {
            // Error en el servidor backend
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
            });
          } else {
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La fecha se actualizó correctamente.",
            });

            this.$router.go({ name: "consultar_imagen_programada" });
          }
        } catch (error) {
          console.error(error);
          // Error en la solicitud HTTP
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error al actualizar la fecha. Por favor, inténtalo de nuevo.",
          });
        }
      }
    },

    async actualizarFechaProgramada(idImagenEnviada, fechaProgramada, cambiarEstado = '0') {
      // Obtener la fecha actual
      const fechaActual = new Date();

      // Convertir la fecha actual a un formato que coincida con fechaProgramada
      const fechaActualFormateada = fechaActual.toISOString();

      const confirmation = await this.$swal({
        title: "¿Estás seguro de asignar esta fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, asignar",
        cancelButtonText: "Cancelar",
      });

      if (confirmation.isConfirmed) {
        // El usuario confirmó la actualización, realizar la solicitud al servidor
        const query = `
          mutation ActualizarFecha(
          $idEnvioImagen      : String!, 
          $fechaProgramada    : DateTime!
          $cambiarEstadoImagen: String
        ) {
          actualizarFechaProgramada(
            idEnvioImagen      : $idEnvioImagen, 
            fechaProgramada    : $fechaProgramada
            cambiarEstadoImagen: $cambiarEstadoImagen
          ) {
              envioImagen {
                id
                fechaProgramada
              }
            }
          }
        `;

        const variables = {
          idEnvioImagen: idImagenEnviada,
          fechaProgramada: fechaProgramada.toString(),
          cambiarEstadoImagen: cambiarEstado
        };

        try {
          const response = await axios.post(rutas.axios + "api", { query, variables });

          if (response.data.errors) {
            // Error en el servidor backend
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
            });
          } else {
            // Actualización exitosa
            await this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La fecha se actualizó correctamente.",
            });

            this.cambiarEstado = '0';
            // Realizar la recarga de la página o cualquier otra acción necesaria
            this.$router.go({ name: "consultar_imagen_programada" });
          }
        } catch (error) {
          console.error(error);
          // Error en la solicitud HTTP
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error al actualizar la fecha. Por favor, inténtalo de nuevo.",
          });
        }
      }
    },

    async getReporteImagenes() {
      const establecimientoUser = getEstablecimientoLS && getEstablecimientoLS();
      const establecimientoSeleccionado = this.isXima
        ? (this.filters?.establecimiento || (establecimientoUser && establecimientoUser.id ? establecimientoUser.id : null))
        : (establecimientoUser && establecimientoUser.id ? establecimientoUser.id : null);
      const idDoctor = getIdDoctorLS();
      const viewAll = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.IMAGENES, ROLES.AUX_IMAGENES, ROLES.AGENDAMIENTO]);

      const params = {
        search: this.filters.search || '',
        establecimiento: establecimientoSeleccionado,
        doctor: viewAll ? '' : idDoctor,
        estadoImagen: this.filters.estadoImagen || '',
        tipoImagen: this.filters.tipoImagen || '',
        fechaDesde: this.filters.fechaDesde || null,
        fechaHasta: this.filters.fechaHasta || null,
        tipoFecha: this.filters.tipoFecha
      }

      const responseImagenes = await imagenesService.getReporteImagenes(params);
      if (!responseImagenes) return;

      const dataarchivo = responseImagenes.dataarchivo

      await actions.cargarArchivos(dataarchivo, "imagenesdb.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
      this.descargandoBase = false
    },




    async getDataTable(excel) {

      if (this.$refs.filterImagenes && this.$refs.filterImagenes.getObservaciones) {
        await this.$refs.filterImagenes.getObservaciones();
      }

      this.loadingTable = true;

      const establecimientoUser = getEstablecimientoLS && getEstablecimientoLS();
      const establecimientoSeleccionado = this.isXima
        ? (this.filters?.establecimiento || (establecimientoUser && establecimientoUser.id ? establecimientoUser.id : null))
        : (establecimientoUser && establecimientoUser.id ? establecimientoUser.id : null);

      const idDoctor = getIdDoctorLS();

      const viewAll = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.IMAGENES, ROLES.AUX_IMAGENES, ROLES.AGENDAMIENTO]);


      const params = {
        search: this.filters.search || '',
        establecimiento: establecimientoSeleccionado,
        doctor: viewAll ? '' : idDoctor,
        estadoImagen: this.filters.estadoImagen || '',
        tipoImagen: this.filters.tipoImagen || '',
        tipoCobertura: this.filters.tipoCobertura || '',
        fechaDesde: this.filters.fechaDesde || null,
        fechaHasta: this.filters.fechaHasta || null,
        page: this.table.currentPage,
        pageSize: this.table.perPage,
        excel: excel || '',
        tipoFecha: this.filters.tipoFecha,
        observaciones: this.filters.observaciones
      }
      const responseImagenes = await imagenesService.getAll(params);

      if (!responseImagenes) return;

      const dataarchivo = responseImagenes.dataarchivo;

      if (excel) {
        actions.cargarArchivos(dataarchivo, "imagenesdb.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
      }
      const filas = Array.isArray(responseImagenes.data)
      ? responseImagenes.data.filter(Boolean) // 🔒 evita items null/undefined
      : [];
      this.items = filas
        .map((item) => {

          let titulares = []

          try {
            let detalles_cita = item.consultamedica.cita.detallescitaSet
            let json_titulares = JSON.parse(detalles_cita[0].detallesTitulares)
            titulares = json_titulares
          } catch (error) { console.log("error en el parseo de json_titulares", error) }

          const fechaRaw = item?.fechaProgramada || null;
          let fechaFormateada = "";
          if (fechaRaw) {
            const fecha = new Date(fechaRaw);
            fechaFormateada = fecha.toLocaleString("es", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
          }

          let cod_cobertura = null
          try {
            let detalles_citas = item?.consultamedica?.cita?.detallescitaSet
            let seguroCita = JSON.parse(detalles_citas[0].detailsSeguro)
            cod_cobertura = seguroCita?.seguroSalud?.code

            console.log("cod_cobertura", cod_cobertura)

          } catch (error) { console.log("teno te rror", error) }


          const fechaCreacionFormateada = `${item.consultamedica.cita?.fechaCita} / ${item.consultamedica.cita?.horaCita}`

          const dataCita = item.consultamedica?.cita
          const especialidadDoctor = dataCita?.doctor?.especialidad?.descripcion || '';
          const codigoEspecialidadDoctor = dataCita?.doctor?.especialidad?.codEsp
            || dataCita?.doctor?.especialidad?.codigo
            || dataCita?.doctor?.especialidad?.id;
          const codigoAlternoEspecialidadDoctor = dataCita?.doctor?.especialidadId
            || dataCita?.doctor?.idEspecialidad;
          const isOdontologiaCE = this.esEspecialidadOdontologiaCe(
            especialidadDoctor,
            codigoEspecialidadDoctor,
            codigoAlternoEspecialidadDoctor
          );

          const pacientePersona = dataCita?.paciente?.persona || {};
          const text = `${pacientePersona.primerApellido || ''} ${pacientePersona.primerNombre || ''}`.trim();
          const value = dataCita?.paciente?.id;
          
          const pacient = { text, value };
          // const msp = item.informes && item.informes.length > 0 && item.informes[0] && item.informes[0].urlMsp
          //   ? item.informes[0].urlMsp
          //   : "No subido";

          const informeImagen = item.informes.length ? item.informes[0] : null;
          let urls_msps_parseados = []

          if (informeImagen) {
            try {
              Object.entries(informeImagen).forEach(([key, value]) => {
                if (value) {
                  try {
                    const parsed = JSON.parse(value);
                    if (parsed && parsed.urls) {
                      Object.entries(parsed.urls).forEach(([k, v]) => {
                        if (v) {
                          urls_msps_parseados.push(v);
                        }
                      });
                    }
                  } catch (innerError) {
                    console.warn(`Error al parsear la propiedad "${key}":`, innerError);
                  }
                }
              });
            } catch (error) {
              console.error("Error general al procesar informeImagen:", error);
            }
          }
          
          let urlMsp = ''
          let coberturasSubidas = true
          
          // const urlMsp = informeMsp?.urls?.["1"] 
          //   ? informeMsp.urls["1"] 
          //   : "No subido";

          let cobertura = item.consultamedica.cita.cobSeleccionada ? item.consultamedica.cita.cobSeleccionada.descripcion : 'No seleccionada'
          const cobertura_tiposeg = cobertura && cod_cobertura && cobertura !== 'PARTICULAR' ? `${cobertura} / ${cod_cobertura}` : cobertura
          const nTitulares = (titulares?.length || 0) + 1;
          const coberturaPaciente = item.informes && item.informes.length > 0 && item.informes[0].urlMsp
            ? (() => {
              try {
                const urlMspData = JSON.parse(item.informes[0].urlMsp);
                return urlMspData.urls && urlMspData.urls["1"] && typeof urlMspData.urls["1"] === "string" && urlMspData.urls["1"].length > 0 ? 1 : 0;
              } catch (e) {
                return 0; // In case urlMsp is not valid JSON
              }
            })()
            : 0;
          
          const coberturaTitular1 = item.informes && item.informes.length > 0 && item.informes[0].urlMspTitular1
            ? (() => {
              try {
                const urlMspData = JSON.parse(item.informes[0].urlMspTitular1);
                return urlMspData.urls && urlMspData.urls["1"] && typeof urlMspData.urls["1"] === "string" && urlMspData.urls["1"].length > 0 ? 1 : 0;
              } catch (e) {
                return 0; // In case urlMsp is not valid JSON
              }
            })()
            : 0;
          
          const coberturaTitular2 = item.informes && item.informes.length > 0 && item.informes[0].urlMspTitular2
            ? (() => {
              try {
                const urlMspData = JSON.parse(item.informes[0].urlMspTitular2);
                return urlMspData.urls && urlMspData.urls["1"] && typeof urlMspData.urls["1"] === "string" && urlMspData.urls["1"].length > 0 ? 1 : 0;
              } catch (e) {
                return 0; // In case urlMsp is not valid JSON
              }
            })()
            : 0;
          let nCoberturasSubidas = coberturaPaciente + coberturaTitular1 + coberturaTitular2;
          const coberturaTrim = (cobertura || '').trim();
          
          if (isOdontologiaCE) {
            urlMsp = "No aplica";
            coberturasSubidas = true;
            nCoberturasSubidas = nTitulares;
          }
          else if(coberturaTrim === 'PARTICULAR'){
            urlMsp = "No aplica"
          }
          else if(urls_msps_parseados.length < nTitulares){
            urlMsp = "No subido"
            coberturasSubidas = false
          }
          
          return {
            idImagenEnviada: item.id,
            token: item.token,

            idPaciente: dataCita?.paciente?.id,
            paciente: `${pacientePersona.identificacion || ''} - ${pacientePersona.primerApellido || ''} ${pacientePersona.primerNombre || ''}`.trim(),
            identificacionPaciente: pacientePersona.identificacion,
            pacient: pacient,

            doctor: `${dataCita?.doctor?.idPersona?.primerApellido || ''} ${dataCita?.doctor?.idPersona?.primerNombre || ''}`.trim(),
            idDoctor: dataCita?.doctor?.id,

            idCita: dataCita?.id,
            nTitulares          : nTitulares,
            nCoberturasSubidas  : nCoberturasSubidas,
            colorArchivoMsp     : nTitulares === nCoberturasSubidas ? 'light-success' : 'light-secondary',
            // fechaCreacion    : `${dataCita.fechaCita} ${dataCita.horaCita}`,
            fechaCreacion: fechaCreacionFormateada,
            imagen: item.imagen?.nombre,
            estadoImagen: item.estadoImagen,
            idEstablecimiento: dataCita?.establecimiento?.id,
            establecimiento: dataCita?.establecimiento?.Descripcion,

            envioImagenSet: item.consultamedica?.envioimagenSet,
            motivoSolicitud: item.motivoSolicitud,
            usuarioCreador: item.usuarioCreador?.username || "No disponible",
            numeroOrden: item.numeroOrdenAs400,
            resumen: item.resumenClinico,
            msp: urlMsp,

            tirilla: dataCita?.urlCodigoDer,
            urlSolImgDer: dataCita?.urlSolImgDer,
            urlsMspPaciente: dataCita?.urlsMspPaciente,
            urlsMspTitular1: dataCita?.urlsMspTitular1,
            urlsMspTitular2: dataCita?.urlsMspTitular2,
            urlsMspTitular3: dataCita?.urlsMspTitular3,
            urlDerivacion: dataCita?.urlDerivacion,
            url007Recibido: dataCita?.url007Recibido,
            fechaProgramada: fechaFormateada,
            cobSeleccionada: {
              id: dataCita?.cobSeleccionada?.id || "",
              descripcion: dataCita?.cobSeleccionada?.descripcion || "",
            },
            cobertura_tiposeg: cobertura_tiposeg,
            cobertura: cobertura,
            fecderivacion: dataCita?.fecderivacion,
            codderivacion: dataCita?.codderivacion,
            titulares: titulares,
            coberturasSubidas : coberturasSubidas
          };
        }
      );

      this.table.totalRows = responseImagenes.total;
      this.loadingTable = false;
      this.descargandoBase = false
    },


    async descargarSolicitudImagenDer(url) {
      if (url) {
        const fileName = decodeURIComponent(url);
        const fullDownloadUrl = `${rutas.axios}file/show${fileName}`;

        try {
          const response = await fetch(fullDownloadUrl);
          if (!response.ok) {
            throw new Error("No se pudo descargar el archivo");
          }

          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = blobUrl;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(link);
        } catch (error) {
          this.$swal({
            title: "Error",
            text: "Un error ocurrió mientras se descargaba el archivo",
            icon: "error",
            confirmButtonText: "Entendido",
          });
        }
      } else {
        this.$swal({
          title: "No se ha subido",
          text: "La solicitud de imagen por derivacion no ha sido subida, por favor subir en editar cita",
          icon: "error",
          confirmButtonText: "Entendido",
        });
      }
    },

    async downloadSolicitudImagen(idImagenEnviada) {
      let idImagen = idImagenEnviada;
      idImagen = idImagen.toString();
      const query = `
        query PlantillaImagenById($idImagen: String!) {
          plantillaImagen(idImagen: $idImagen) {
            status
            message
            imgarchivo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: {
            idImagen: idImagen,
          },
        });
        if (response.status === 200) {
          if (response.data.data.plantillaImagen) {
            const item = response.data.data.plantillaImagen.imgarchivo;
            actions.cargarArchivos(
              item,
              "imagen_" + idImagen + ".pdf",
              "data:application/pdf;base64"
            );
          } else {
            console.error("Error al descargar el archivo:", error);
            this.$swal({
              title: "Error",
              text: "El archivo no existe, comunicar con el adminsitrador sistema",
              icon: "error",
              confirmButtonColor: "#089599",
            });
          }
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    async onViewFile12b(tokenImagen) {


      this.load12b = true;
      const urlTemp = await imagenesService.getUrlView12b(tokenImagen);

      if (!urlTemp) {
        this.load12b = false;
        this.$swal({
          title: 'Error',
          text: "El archivo no existe",
          icon: 'error',
        });
        return;
      }

      this.modalFile.isRutaCompleta = true;
      this.modalFile.fileToView = urlTemp;
      this.modalFile.isVisible = true;
      this.load12b = false;
    },


    async downloadInformeImagen(idImagenEnviada) {
      const idImagen = idImagenEnviada.toString();

      const query = `
        query InformeImagen12bById($idImagen: String!) {
          informeImagen12b(idImagen: $idImagen) {
            status
            message
            imgarchivo
          }
        }
      `;

      const variables = {
        idImagen
      }

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        if (response.status === 200) {
          if (response.data.data.informeImagen12b.status === 'error') {
            this.$swal({
              title: "Error",
              text: "Antes de generar el informe debe completar todos los campos",
              icon: "error",
              confirmButtonColor: "#089599",
            });
            return
          }
          if (response.data.data.informeImagen12b) {
            const item = response.data.data.informeImagen12b.imgarchivo;
            actions.cargarArchivos(
              item,
              "imagen_" + idImagen + ".pdf",
              "data:application/pdf;base64"
            );
          } else {
            console.error("Error al descargar el archivo:");
            this.$swal({
              title: "Error",
              text: "El archivo no existe, comunicar con el adminsitrador sistema",
              icon: "error",
              confirmButtonColor: "#089599",
            });
          }
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    buscarImagenesProgramadas() {
      this.table.currentPage = 1;
      this.items = [];
      this.getDataTable();
    },

    viewItem(idDoc) {
      this.$router.push({
        name: "ver_doctor",
        params: { id: idDoc },
      });
    },

    removeItemid(idImagenEnviada) {
      const mesa = this.fetchRemoveEnvioImagen(idImagenEnviada);
    },

    async fetchRemoveEnvioImagen(idImagenEnviada) {
      this.$swal({
        title: "Estas seguro de eliminar imagen por programar?",
        text: "No seras capaz de revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar esto!",
        cancelButtonText: "No, cancelar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Call the API or method to remove the item here
          try {
            const argEnvImg = {
              id: idImagenEnviada,
            };
            const response = await axios.post(rutas.axios + "api", {
              query: `mutation CancelarEnvio($id: String!) {
                  removerEnvioImagen(envioDatos: { id: $id }) {
                    status
                    message
                  }
                }
              `,

              variables: argEnvImg,
            });

            if (response.status === 200) {
              if (response.data.data.removerEnvioImagen.status === "success") {
                if (response.status === 200) {
                  this.$swal({
                    title: "Borrado!",
                    text: "Tu registro ha sido eliminado",
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router
                  .push({ name: "consultar_imagen_programada" })
                  .catch((err) => {
                    if (err.name !== "NavigationDuplicated") {
                      console.error(err);
                    }
                  });
              } else {
                this.$swal({
                  title: "Error",
                  text: response.data.data.removerEnvioImagen.message,
                  icon: "error",
                  confirmButtonColor: "#089599",
                });
              }
            }
          } catch (err) {
            console.log(err);
            return "Error al eliminar doctor";
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: "Cancelado",
            text: "Your registro esta seguro :)",
            icon: "error",
            confirmButtonColor: "#3085d6",
          });
        }
      });
    },


    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },


    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },


    syncFilters() {
      const newValue = this.stFilterImagenes;

      this.filters = {
        search: newValue?.search || null,
        establecimiento: newValue?.establecimiento || null,
        estadoImagen: newValue?.estadoImagen || null,
        tipoFecha: newValue?.tipoFecha || null,
        tipoImagen: newValue?.tipoImagen || null,
        fechaDesde: newValue?.fechaDesde || null,
        fechaHasta: newValue?.fechaHasta || null,
        tipoCobertura: newValue?.tipoCobertura || null,
        observaciones: newValue?.observaciones || null
      }
      this.table.currentPage = 1;
    }
  },


  computed: {

    ...mapState({
      stFilterImagenes: state => state.generals.filterImagenes,
    }),
    showButtonReportes(){
      const hasPermission = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.ESTADISTICAS, ROLES.JEFE_VALIDACIONES, ROLES.JEFE_AUDITOR, ROLES.AUDITOR, ROLES.DIGITADOR]);
      return hasPermission;
    },
    isAdmin() {
      return comprobarRoles([ROLES.ADMINISTRADOR]);
    },

    fields() {
      const baseFields = [

        {
          key: "paciente",
          label: "Paciente",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "doctor",
          label: "Doctor",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "imagen",
          label: "Imagen",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "fechaCreacion",
          label: "Fecha de Atencion",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "fechaProgramada",
          label: "Fecha Programada",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "estadoImagen",
          label: "Estado",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "motivoSolicitud",
          label: "Motivo Solicitud",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "cobertura",
          label: "Cobertura",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "numeroOrden",
          label: "Orden AS400",
          sortable: true,
          thClass: "text-center",
        },
        { key: "msp", label: "MSP", sortable: true, thClass: "text-center" },
        {
          key: "usuarioCreador",
          label: "Usuario",
          sortable: true,
          thClass: "text-center",
          width: "150px",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "solicitudimagen",
          label: "Informes",
          sortable: true,
          thClass: "text-center",
        },
      ];

      if (this.isXima) {
        baseFields.unshift({
          key: "establecimiento",
          label: "Establecimiento",
          sortable: true,
          thClass: "text-center",
        });
      }

      return baseFields;
    },

    filteredOptions() {
      return [];
    },

    noOptionsMessage() {
      if (this.searchText.length > 0) {
        return this.filteredOptions.length > 0
          ? ""
          : "Sin resultados para tu búsqueda.";
      }
      return "Ingresa palabras clave para buscar";
    },


    showMultiplesEstablecimientos() {
      const hasPermission = comprobarRoles([]);
      return hasPermission;
    },
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },
    // show actions
    showButtonEditarDerivada() {
      const hasPermission = comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO]);
      return hasPermission
    },

    showButtonProgramarImagen() {
      const hasPermission = comprobarRoles([ROLES.ADMINISTRADOR, ROLES.JEFE_MEDICO, ROLES.AGENDAMIENTO]);
      if (hasPermission) return true;

      const posiblesDoctores = [];
      if (this.doctorInfo) posiblesDoctores.push(this.doctorInfo);
      if (Array.isArray(this.doctorEspecialidades) && this.doctorEspecialidades.length) {
        posiblesDoctores.push(...this.doctorEspecialidades);
      }

      const tieneOdontologia = posiblesDoctores.some(doc => this.tieneEspecialidadOdontologia(doc));

      if (!tieneOdontologia) return false;

      return true;
    },

    showButtonEditarSolicitud() {
      const hasPermission = comprobarRoles([ROLES.ADMINISTRADOR, ROLES.JEFE_MEDICO, ROLES.DOCTOR]);
      return hasPermission;
    },

    showButtonEditarProcesada() {
      const hasPermission = comprobarRoles([ROLES.ADMINISTRADOR, ROLES.JEFE_MEDICO, ROLES.IMAGENES, ROLES.AUX_IMAGENES, ROLES.AGENDAMIENTO, ROLES.ADMISION]);
      return hasPermission;
    },

    showButtonDeleteImagen() {
      return comprobarRoles([ROLES.ADMINISTRADOR, ROLES.JEFE_MEDICO])
    },

    showInforme12A() {
      const hasPermission = comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO, ROLES.ADMINISTRADOR, ROLES.JEFE_AUDITOR, ROLES.AUDITOR]);
      return hasPermission;
    },

    showInforme12B() {
      const hasPermission = comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO, ROLES.AGENDAMIENTO, ROLES.ADMINISTRADOR, ROLES.JEFE_AUDITOR, ROLES.AUDITOR]);
      return hasPermission;
    },

    showInformeActa() {
      const hasPermission = comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO, ROLES.ADMINISTRADOR, ROLES.AGENDAMIENTO]);
      return hasPermission;
    },

    showButtonTirilla() {
      const hasPermission = comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO, ROLES.ADMINISTRADOR]);
      return hasPermission;
    },

    showButtonMSP() {
      const hasPermission = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.ADMINISTRADOR]);
      return hasPermission;
    },

    showButtonImagen() {
      const hasPermission = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.ADMINISTRADOR]);
      return hasPermission;
    }

  },

  watch: {

    stFilterImagenes: {
      deep: true,
      handler() {
        this.syncFilters();
        this.getDataTable();
      }
    },

    // filters: {
    //   deep: true,
    //   handler() {
    //     localStorage.setItem('filtersImagenes', JSON.stringify(this.filters));
    //   },
    // }
  }
};
</script>
<style lang="scss" scoped>
.light-success {
    background-color: #d4edda;
    color: #155724;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }
  
  .light-secondary {
    background-color: #f8d7da;
    color: #721c24;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }
</style>
